export default "__VITE_ASSET__Cglbh8dB__"